import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _property from 'lodash/property';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _constant from 'lodash/constant';
import sitesReader from './OemSites';
import UserReader from './User';
import { getValueFromLocalStorage } from '../utils/localStorage';
import { getValueFromSessionStorage } from '../utils/sessionStorage';
import { getDealerContextFromSessionStorage, isContextValid } from '../utils/auth';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../app.constants';
import TRANSLATIONS_LS_CACHE_KEYS from '../constants/translationsLSCacheKeys';

var dseUrl = function dseUrl() {
  var user = userInfo();
  return "".concat(user.apiURL, "/");
};

var cmdsUrl = _property('TEKION_CDMS_URL'); // deprecated


var cdmsUrl = _property('TEKION_CDMS_URL');

var loginUrl = _property('TEKION_LOGIN_URL');

var globalUrl = _property('TEKION_GLOBAL_DSE_URL');

var tdpUrl = _property('TEKION_TDP_URL');

var service = _property('TEKION_LOGIN_SERVICE');

var internalEdgeUrl = function internalEdgeUrl() {
  return typeof window !== 'undefined' && window.sessionStorage && getValueFromSessionStorage('internalEdgeUrl');
};

var newLoginService = _property('TEKION_NEW_LOGIN_SERVICE');

var microServiceApp = _property('MICRO_SERVICE_APP');

var paymentMode = _property('TEKION_PAYMENT_MODE');

var buildEnv = _property('BUILD_ENV');

var buildVersionWithEnv = _property('BUILD_VERSION_WITH_ENV');

var appVersion = _property('VERSION');

var tapSupportChatScript = _property('TAP_SUPPORT_CHAT_SCRIPT');

var tapSupportChatBrandId = _property('TAP_SUPPORT_CHAT_BRAND_ID');

var tekionDataUrl = _property('TEKION_DATA_URL');

var tekionDataApiKey = _property('TEKION_DATA_API_KEY');

var tekionAmplitudeApiKey = _property('TEKION_AMPLITUDE_API_KEY');

var isExportMode = function isExportMode() {
  return typeof window !== 'undefined' && window.sessionStorage && getValueFromSessionStorage('isExportMode') === 'true';
};

var canMakeInternalCalls = function canMakeInternalCalls() {
  return typeof window !== 'undefined' && window.sessionStorage && getValueFromSessionStorage('canMakeInternalCalls') === 'true';
};

var apiToken = function apiToken() {
  var exportMode = isExportMode();
  /**
   * Token information is saved in session storage as this information does not need to to be shared across tabs.
   * In the export server different tabs with the same domain can have different set of dealer, user, tenant
   */

  if (exportMode) {
    return getValueFromSessionStorage('t_token');
  }

  return getValueFromLocalStorage('t_token');
};

var userInfo = function userInfo() {
  if (global.isFromMobile) {
    return global.userInfo;
  }

  var exportMode = isExportMode();
  /**
   * User information is saved in session storage as this information does not need to to be shared across tabs.
   * In the export server different tabs with the same domain can have different set of dealer, user, tenant
   */

  if (exportMode) {
    return JSON.parse(getValueFromSessionStorage('t_user')) || EMPTY_OBJECT;
  }

  var context = getDealerContextFromSessionStorage();

  var user = _objectSpread(_objectSpread({}, JSON.parse(getValueFromLocalStorage('t_user')) || EMPTY_OBJECT), {}, {
    envPrefix: getValueFromSessionStorage('envPrefix')
  });

  if (!isContextValid(context)) return user;
  var dealerId = context.dealerId,
      tekSiteId = context.tekSiteId,
      workspaceId = context.workspaceId,
      isWorkspace = context.isWorkspace;

  if (isWorkspace === 'true' && !_isNil(workspaceId)) {
    return _objectSpread(_objectSpread(_objectSpread({}, user), context), {}, {
      isWorkspace: true
    });
  }

  var dealerOemObject = _find(UserReader.dealerOemSites(user), function (item) {
    return sitesReader.dealerId(item) === dealerId;
  });

  var siteIdObject = _find(_get(dealerOemObject, 'oemSites', EMPTY_ARRAY), function (site) {
    return sitesReader.siteId(site) === tekSiteId;
  });

  return _objectSpread(_objectSpread(_objectSpread({}, user), context), {}, {
    isWorkspace: false,
    isMainSite: sitesReader.mainSite(siteIdObject)
  });
};

var dseUserInfo = function dseUserInfo() {
  return JSON.parse(getValueFromLocalStorage('dse_t_user')) || EMPTY_OBJECT;
};

var sentryDsn = _property('SENTRY_DSN');

var federationEnabledApps = function federationEnabledApps(env) {
  return new Set(_get(env, 'FEDERATION_ENABLED_APPS') || EMPTY_ARRAY);
};

var federationMigratedApps = function federationMigratedApps(env) {
  return new Set(_get(env, 'FEDERATION_MIGRATED_APPS') || EMPTY_ARRAY);
};

var pspdfkitLicenseKey = _property('PSPDFKIT_LICENSE_KEY');

var fullCalendarLicenseKey = _property('FULL_CALENDAR_LICENSE_KEY');

var chaosjunkieEnabled = _property('TEKION_CHAOSJUNKIE_ENABLED');

var isOEMApplicationTrack = function isOEMApplicationTrack() {
  return false;
};

var getCurrentLanguageId = function getCurrentLanguageId() {
  if (global.isFromMobile) {
    return _get(global, 'applicationPreferences.tekLocale');
  }

  return getValueFromSessionStorage(TRANSLATIONS_LS_CACHE_KEYS.CURRENT_LOCALE);
};

var getCdnStaticAssetUrl = _property('TEKION_CDN_STATIC_ASSET_URL');

var getTpayAWSUrl = _property('TEKION_PAY_AWS_URL');

export default {
  isOEMApplicationTrack: isOEMApplicationTrack,
  apiToken: apiToken,
  cmdsUrl: cmdsUrl,
  dseUrl: dseUrl,
  loginUrl: loginUrl,
  tdpUrl: tdpUrl,
  userInfo: userInfo,
  dseUserInfo: dseUserInfo,
  globalUrl: globalUrl,
  service: service,
  microServiceApp: microServiceApp,
  buildEnv: buildEnv,
  buildVersionWithEnv: buildVersionWithEnv,
  appVersion: appVersion,
  sentryDsn: sentryDsn,
  paymentMode: paymentMode,
  pspdfkitLicenseKey: pspdfkitLicenseKey,
  newLoginService: newLoginService,
  federationEnabledApps: federationEnabledApps,
  federationMigratedApps: federationMigratedApps,
  canMakeInternalCalls: canMakeInternalCalls,
  internalEdgeUrl: internalEdgeUrl,
  cdmsUrl: cdmsUrl,
  tekionDataUrl: tekionDataUrl,
  tekionDataApiKey: tekionDataApiKey,
  isExportMode: isExportMode,
  fullCalendarLicenseKey: fullCalendarLicenseKey,
  chaosjunkieEnabled: chaosjunkieEnabled,
  tapSupportChatScript: tapSupportChatScript,
  tapSupportChatBrandId: tapSupportChatBrandId,
  tekionAmplitudeApiKey: tekionAmplitudeApiKey,
  getCurrentLanguageId: getCurrentLanguageId,
  getCdnStaticAssetUrl: getCdnStaticAssetUrl,
  getTpayAWSUrl: getTpayAWSUrl
};